module.exports = __webpack_public_path__ + "images/7ad8e060bc761a9fb8cc553e0bbaa1fc-profile_overlay.jpg";